<template>
  <div id="page-Templateletter" class="d-flex">    
       <!-- <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div> -->
    <div class="layout-content container-fluid ">
      <HeadingUser />
      <div class="page-Templateletter py-3">
        <div class="container" style="border:1px solid #cecece;">                      
          <div class="row">
            <div class="col-12">
              <img align="center" width="475" height="100" 
                :src="serverPath+'/'+this.routes.header_img+'?'+this.number"
                @error="imageLoadError"
              >
            </div> 
          </div>
          <div class="row">
            <div class="col-12">
              <p class="p3"><br>
                <i>/Ciudad, fecha/</i><br>
                <b>Sres.<br>
                Bavaria S.A</b><br>                
                <i>/Nombre Business Partner/</i><br>
                <i>/Cargo Business Partner/</i><br>
                <br>
                <b>Ref: Permisos Sindicales<br>
                <br>
                Cordial saludo,<br></b>
                <i>/Nombre del solicitante/, /Cargo del solicitante/ del /Sindicato/</i>, <b>me dirijo a 
                ustedes para informarles que el día</b><i> /Fecha1/</i><b> con motivo de</b><i> /motivo del permiso/ </i>
                <b>haremos uso de nuestros permisos sindicales para los siguientes socios: </b><br><br>
                <i>/colaborador uno/, /colaborador dos/...</i><br><br>
                <b>{{this.routes.legal_context}}</b><br><br>
                <i>/Información Adicional/</i><br><br>
                <b>Agradezco la atención prestada y quedo atento a su pronta respuesta.<br> 
                Cordialmente</b>

              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <img align="center" style="width:100px;height:100px;"
                :src="serverPath+'/'+this.routes.signature1+'?'+this.number"
                @error="imageLoadError"
              >
            </div>
            <div class="col-6">
              <img align="center" style="width:100px;height:100px;"
                :src="serverPath+'/'+this.routes.signature2+'?'+this.number"
                @error="imageLoadError"
              >
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <p class="p3">{{this.routes.name1}}</p>
            </div>
            <div class="col-6">
              <p class="p3">{{this.routes.name2}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <p class="p3">{{this.routes.position1}}</p>
            </div>
            <div class="col-6">
              <p class="p3">{{this.routes.position2}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <img align="center" width="475" height="100" 
              :src="serverPath+'/'+this.routes.footer_img+'?'+this.number"
              @error="imageLoadError"
              >
            </div>
          </div>
        </div>          
      <!-- .layout-content -->
      </div>
    </div>
  </div>
  <!-- #page-request -->
</template>

<script>
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";

export default {
  name: "TemplateLetter",
  components: {  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      routes: [],
    };
  },
  beforeMount() {
    this.actGetTemplate().then(() =>{
                  this.routes = this.template.data;

                }).catch((response) => {
                  this.error.flag = true;
                  this.error.class = "is-invalid";
                  this.error.message = "No se pudo conectar al servicio: "+response;
                });
  }, 
  computed: {
    ...mapState("modEditLetter", ["template"]),

    number(){
      return new Date();
    }
  },
  methods: {
    ...mapActions("modEditLetter", [
      "actGetTemplate",
    ]),
    
    imageLoadError(event) {
      event.target.src = "";
    }
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.page-letter {
  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 16px;
    color: #303030;
    padding-left: 5%;
    text-align: right;
    vertical-align: bottom;
    text-decoration: underline;
  }
  .p3 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #454545;
  }

  img {
    width: 100%;
    height: auto;
  }
}
</style>